export default "<app-salary-simulation [showPdf]=\"true\">\n\n</app-salary-simulation>\n"